import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createAudio(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): AudioInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Audio, parentId, masterBlockId),
    url: '',
  }
}
